import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-5 lg:mt-20',
    video: 'h-auto w-full max-w-[1024px]'
  }
});
